module.exports = __webpack_public_path__ + "img/engine-oil-tire.adc19e55.png";